var SelectMode = /* @__PURE__ */ ((SelectMode2) => {
  SelectMode2["oneByOne"] = "one-by-one";
  SelectMode2["onlyOne"] = "only-one";
  SelectMode2["many"] = "many";
  return SelectMode2;
})(SelectMode || {});
export {
  SelectMode
};
//# sourceMappingURL=types.js.map
